import { useRovingFocus } from './rovingFocus';

/**
 * Navigation clavier du motif ARIA « tabs », partagée par les trois `role="tablist"`
 * du projet (console Admin/Superadmin, Dédoublonnage, Paramètres).
 *
 * Le motif PROMET ←/→/Home/End à qui lit `role="tab"` : sans ces touches, la promesse
 * n'est pas tenue, et les 14 onglets de la console encombrent l'ordre de tabulation.
 *
 * ACTIVATION MANUELLE (et non automatique) : les flèches DÉPLACENT le focus, elles ne
 * changent pas d'onglet — Entrée/Espace l'activent (clic natif du `<button>`). C'est le
 * bon choix ici : chaque panneau déclenche des requêtes réseau, les traverser à la
 * flèche en émettrait une par onglet.
 *
 * Côté rendu, chaque onglet doit porter un `tabIndex` MOBILE (`0` sur l'onglet
 * sélectionné, `-1` sur les autres) pour que la tabulation n'entre qu'UNE fois dans la
 * barre — cf. `rovingTabIndex`.
 *
 * L'ALGORITHME lui-même vit dans `rovingFocus.ts`, partagé avec les menus et les
 * `radiogroup` : les onglets désactivés y sont ENJAMBÉS (cf. le défaut corrigé qui y est
 * documenté), ce que la version locale faisait déjà à sa façon.
 */

export { rovingTabIndex } from './rovingFocus';

/** Gestionnaire à poser sur le conteneur `role="tablist"`. */
export function useRovingTabs(): (e: React.KeyboardEvent<HTMLElement>) => void {
  return useRovingFocus({
    itemSelector: '[role="tab"]',
    orientation: 'horizontal',
    activate: 'manual',
  });
}
